module.exports = __webpack_public_path__ + "img/image4.43746868.png";